import { styled } from '@mui/material/styles';
import { StyledSubmitButton } from '../components/user-auth-components/common-auth-styles';

export const StyledActionButton = styled(StyledSubmitButton)(({ theme }) => ({
  width: theme.convert.pxToRem(174),
}));
